// React core imports
import React from 'react';
import ReactDOM from 'react-dom';

// Main App component
import App from './App';

// Performance measurement utility (optional)
import reportWebVitals from './reportWebVitals';

// Global CSS styles
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap core CSS
import './assets/css/style.css';               // Custom global styles
import './assets/css/responsive.css';          // Responsive overrides

// Mount the main App component to the root DOM node
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// Measure web performance (optional):
// To use, pass a logging function like: reportWebVitals(console.log)
// Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
